module.exports = __webpack_public_path__ + "static/media/hero-with-coins.e599e75e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero-with-coins.svg
// module id = 283
// module chunks = 0